import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface ICustomerWidgetState {
  isValidation?: boolean;
  activeStep?: number;
  maxStep?: number;
  isCompleted?: boolean;
}

const initialState: ICustomerWidgetState = {
  isValidation: false,
  activeStep: 0,
  maxStep: 4
};

export const customerWidgetSlice = createSlice({
  name: 'newCustomerWidget',
  initialState,
  reducers: {
    setIsValidation: (state, action: PayloadAction<boolean>) => {
      state.isValidation = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setPrevStep: (state) => {
      state.activeStep = state.activeStep - 1;
    },
    setNextStep: (state) => {
      state.activeStep = state.activeStep + 1;
    },
    completed: (state) => {
      state.isCompleted = true;
    },
    getDataByStep: (state, action: PayloadAction<number>) => {
      const data = localStorage.getItem('customerWidget');
      const parsedData = data ? JSON.parse(data) : {};
debugger;
      return parsedData[action.payload];
    },
    saveToStorage: (state, action: PayloadAction<any>) => {      
      const data = localStorage.getItem('customerWidget');
      let parsedData = data ? JSON.parse(data) : {};

      localStorage.setItem('customerWidget', JSON.stringify({
        ...parsedData,
        ...action.payload.data,
        [action.payload.step]: action.payload.data //@deprecated
      }));
    },
    // readFromStorage: (state, action: PayloadAction<{ step: number, data: any }>) => {
    //   console.log('saveToStorage', action.payload);
    //   const data = localStorage.getItem('customerWidget');
    //   let parsedData = data ? JSON.parse(data) : {};

    //   localStorage.setItem('customerWidget', JSON.stringify({
    //     ...parsedData,
    //     [action.payload.step]: action.payload.data
    //   }));
    // },
    getData: (state, action: PayloadAction<any>) => {
      const data = localStorage.getItem('customerWidget');
      //state.data = data ? JSON.parse(data) : null;
    }   
  }  
});

export const selectCustomerWidgetValidation = (state: RootState) => state.newCustomerWidget.isValidation;
export const selectCustomerWidgetActiveStep = (state: RootState) => state.newCustomerWidget.activeStep;
export const selectCustomerWidgetMaxStep = (state: RootState) => state.newCustomerWidget.maxStep;

export const {
  setIsValidation,
  setActiveStep,
  setPrevStep,
  setNextStep,
  saveToStorage,
  completed,
  getDataByStep,
} = customerWidgetSlice.actions;

export default customerWidgetSlice.reducer;
